import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class LoggingService {
  private ngxLogger = inject(NGXLogger);

  trace(message?: unknown | (() => unknown), ...additional: unknown[]): void {
    this.ngxLogger.trace(message, additional);
  }

  debug(message?: unknown | (() => unknown), ...additional: unknown[]): void {
    this.ngxLogger.debug(message, additional);
  }

  info(message?: unknown | (() => unknown), ...additional: unknown[]): void {
    this.ngxLogger.info(message, additional);
  }

  log(message?: unknown | (() => unknown), ...additional: unknown[]): void {
    this.ngxLogger.log(message, additional);
  }

  warn(message?: unknown | (() => unknown), ...additional: unknown[]): void {
    this.ngxLogger.warn(message, additional);
  }

  error(message?: unknown | (() => unknown), ...additional: unknown[]): void {
    this.ngxLogger.error(message, additional);
  }

  fatal(message?: unknown | (() => unknown), ...additional: unknown[]): void {
    this.ngxLogger.fatal(message, additional);
  }
}
